export const chatbotQueryKeys = {
  conversations: ['chatbot', 'conversations'] as const,
  conversation: (conversationId: string) => ['chatbot', 'conversation', conversationId] as const,
};
